import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../hooks';

const ActivityMonitor = ({ children }) => {
  const { onLogout } = useAuth();
  const [lastActivity, setLastActivity] = useState(Date.now());
  const LOGOUT_TIME = 30 * 60 * 1000; // 30 minutes

  const resetTimer = useCallback(() => {
    setLastActivity(Date.now());
  }, []);

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'touchstart', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    const interval = setInterval(() => {
      if (Date.now() - lastActivity > LOGOUT_TIME) {
        onLogout();
      }
    }, 1000);

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearInterval(interval);
    };
  }, [lastActivity, onLogout, resetTimer]);

  return children;
};

export default ActivityMonitor;
